function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { HStack } from 'native-base';
import React from 'react';
const SummaryTableRow = _ref => {
  let {
    children,
    borderBottomWidth,
    id,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(HStack, _extends({}, rest, {
    justifyContent: "space-between",
    borderBottomWidth: borderBottomWidth,
    borderBottomColor: "#cccccc",
    pl: [4, 10, 10],
    pr: [4, 20, 20],
    alignItems: "baseline",
    pt: "5",
    minH: "16",
    key: id
  }), children);
};
SummaryTableRow.defaultProps = {
  borderBottomWidth: 1
};
export default SummaryTableRow;
//# sourceMappingURL=index.js.map